// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--c51ee";
export var loader = "styles-module--loader--3ebb6";
export var loaderButton = "styles-module--loaderButton--a5272";
export var spin = "styles-module--spin--d8e14";
export var state = "styles-module--state--7a873";
export var visuallyHidden = "styles-module--visuallyHidden--51470";